import styled from 'styled-components';

import * as text from '@/components/general/TextStyles';
import { BorderLinkStyle } from '@/components/general';

export const ButtonSee = styled.div`
  font-size: 17px;
  ${BorderLinkStyle}
  &::before {
    bottom: 0px;
  }
`;

export const TagsBox = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 10px;
  row-gap: 10px;
`;

export const TemplateBox = styled.section`
  width: 100%;
  max-width: 1105px;
  margin: 0 auto;
`;

export const BootstrapBox = styled.div`
  margin-top: 130px;
  margin-bottom: 100px;

  @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
    width: 100%;
    margin-top: 70px;
    margin-bottom: 70px;
  }
`;

export const BootstrapTitle = styled.h2`
  ${text.FS42}
  text-align: center;
  margin-bottom: 100px;

  @media (max-width: ${(props) => props.theme.breakpoints.md}px) {
    margin-bottom: 70px;
  }
`;

export const BootstrapRow = styled.div`
  display: flex;
  justify-content: center;
  column-gap: 200px;

  @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
    column-gap: 20px;
    justify-content: space-around;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.md}px) {
    flex-direction: column;
    row-gap: 70px;
  }
`;

export const BootstrapElement = styled.div``;

export const ElementTop = styled.div`
  font-size: 64px;
  line-height: 75px;
  color: ${(props) => props.theme.colors.blue};
  text-align: center;
`;

export const ElementBottom = styled.div`
  ${text.FS24}
  color: ${(props) => props.theme.colors.grayText};
  margin-top: 7px;
  text-align: center;
`;

export const MainScreensSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const MainScreensColor = styled.div`
  width: 100vw;
  background-color: #f7f7f7;
  display: flex;
  justify-content: center;
`;

interface IMainScreensBox {
  $isOpen: boolean;
}
interface IAdaptiveHeight {
  $adaptiveHeight?: number;
}

export const MainScreensBox = styled.div<IMainScreensBox & IAdaptiveHeight>`
  height: ${(props) =>
    props.$isOpen ? `${props.$adaptiveHeight + 180}px` : '1175px'};
  overflow: hidden;
  width: 100%;
  max-width: 1356px;
  margin: 0 -60px;
  padding: 100px 60px;
  position: relative;
  transition: 1s height ease;

  @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
    margin: 0 -28px;
    padding: 100px 28px;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.sm}px) {
    margin: 0 -20px;
    padding: 100px 20px;
  }
`;

interface IMainScreensShadow {
  $exist: boolean;
}

export const MainScreensShadow = styled.div<IMainScreensShadow>`
  display: ${(props: IMainScreensShadow) => (props.$exist ? 'block' : 'none')};
  background: linear-gradient(180deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);
  transform: rotate(-180deg);
  width: 100%;
  height: 230px;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 1;
`;

export const MainScreensTitle = styled.h4`
  position: absolute;
  left: 60px;
  top: 50px;
  font-size: 22px;
  line-height: 145%;
  font-weight: ${(props) => props.theme.weights.regular};

  @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
    left: 28px;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.sm}px) {
    left: 20px;
  }
`;

export const MainSceensGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, 260px);
  justify-content: space-between;
  row-gap: 95px;
  column-gap: 30px;

  @media (max-width: 896px) {
    justify-content: space-around;
    row-gap: 50px;
  }
`;

export const ScreenImageBox = styled.div`
  height: 564px;
  width: 260px;
  border-radius: 30px;
  overflow: hidden;
  box-shadow: 0px 20px 40px -10px rgba(0, 0, 0, 0.1);
`;

export const ButtonBox = styled.div`
  margin-top: 40px;
`;

export const DescriptionSection = styled.section`
  display: flex;
  width: 100%;
  max-width: 1105px;
  margin: 120px auto 0;
  display: flex;
  justify-content: space-between;
  column-gap: 50px;

  @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
    flex-direction: column-reverse;
    row-gap: 60px;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.sm}px) {
    margin-top: 55px;
  }
`;

export const TextBox = styled.div`
  max-width: 542px;
  display: flex;
  flex-direction: column;
  row-gap: 35px;

  @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
    max-width: none;
    row-gap: 20px;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.sm}px) {
    width: 100%;
    row-gap: 15px;
  }
`;

export const CharacteristicBox = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 17px;
  width: 100%;
`;

export const CharacteristicTitle = styled.div`
  ${text.FS17_NOT_CHANGE}
  font-weight: ${(props) => props.theme.weights.semiBold};
`;

export const Title = styled.h3`
  font-size: 24px;
  line-height: 28px;
  margin-top: 15px;

  @media (max-width: ${(props) => props.theme.breakpoints.sm}px) {
    margin-top: 45px;
  }

  &:first-child {
    margin-top: 0;
  }
`;

export const Description = styled.p`
  font-size: 16px;
  line-height: 150%;
  font-weight: ${(props) => props.theme.weights.regular};
  color: ${(props) => props.theme.colors.grayText};
  margin-top: -15px;

  @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
    margin-top: 0;
  }
`;

export const List = styled.ul`
  font-size: 16px;
  line-height: 150%;
  font-weight: ${(props) => props.theme.weights.regular};
`;

export const ListItem = styled.li`
  list-style: disc;
`;

export const FeaturesBox = styled.div`
  max-width: 430px;
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 60px;
  margin-top: 3px;

  @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
    max-width: 600px;
    margin-top: 0px;
  }
`;

export const FeaturesList = styled.ul`
  width: 100%;
  margin-top: -2px;
`;
